@import '../../../../../../../../constants/spacing.module.less';

.section-title-container {
  display: flex;
  align-items: center;
  gap: @space-8;
  padding: @space-8 @space-16 @space-8 @space-0;
  cursor: pointer;
}

.section-expander-icon {
  flex-shrink: 0;
  color: var(--grey-900);
  height: 10px;
  width: 16px;
}
